import { useQuery } from '@tanstack/react-query';
import { fetchArticleDetail } from '../article.api';

export const useArticleQuery = (articleId: string) => {
  const query = useQuery({
    queryKey: ['article', articleId],
    queryFn: async () => {
      const data = await fetchArticleDetail(articleId);
      return data;
    },
    enabled: !!articleId,
    // Prevent duplicate refetches when multiple components mount and use the same query
    staleTime: 60 * 1000, // consider fresh for 1 minute
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });

  return query;
};
